// /Users/pramod/Desktop/school-erp/frontend/src/components/ScrollToTop.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Simple try-catch to prevent errors
    try {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    } catch (e) {
      // Silently handle any errors
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;